import { render, staticRenderFns } from "./BbeeProductosServiciosMP.vue?vue&type=template&id=39014f1d"
import script from "./BbeeProductosServiciosMP.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosMP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports